import React from 'react';
import IconMdi from '@mdi/react';
import { COLORS_WITH_OPACITY } from '../colors';
const Icon = React.forwardRef((props, ref) => {
    const convertSize = (iconSize) => {
        switch (iconSize) {
            case '12px': {
                return 0.5;
            }
            case '16px': {
                return 0.667;
            }
            case '20px': {
                return 0.8335;
            }
            case '24px': {
                return 1;
            }
            case '28px': {
                return 1.1667;
            }
            case '32px': {
                return 1.3335;
            }
            case '36px': {
                return 1.5;
            }
            case '40px': {
                return 1.667;
            }
            default: {
                return iconSize;
            }
        }
    };
    const convertColor = (color, opacity = 1) => {
        return color + Math.round(opacity * 255).toString(16);
    };
    return (React.createElement(IconMdi, { ref: ref, id: props.id, className: props.className, size: props.size ? convertSize(props.size) : 1, color: props.color ? convertColor(props.color, props.opacity) : COLORS_WITH_OPACITY.colorText, path: props.path, title: props.title }));
});
export default Icon;
//# sourceMappingURL=Icon.js.map